import { Table as BaseTable, TableProps } from 'antd';

import './table.scss';

const Table = <RecordType extends object = any>(props: TableProps<RecordType>) => {
  return <BaseTable className="tableCustom" {...props} showSorterTooltip={false} />;
};

export default Table;
